import script from "./ExperienceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperienceView.vue?vue&type=script&setup=true&lang=js"

import "./ExperienceView.vue?vue&type=style&index=0&id=8ed6ae8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ed6ae8e"]])

export default __exports__